<template>
  <v-card class="ma-10" flat tile>
    <v-row>
      <month-picker v-model="month" label="Select Month"></month-picker>
      <v-spacer />

      <div class="d-flex ">
        <v-btn
          @click="printReport"
          class="elevation-0"
          color="primary"
          outlined
          elevation="2"
        >
          <v-icon left> mdi-printer</v-icon>
          Print</v-btn
        >
      </div>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="freeListingViews"
      :items-per-page="10"
      :loading="loading"
    ></v-data-table>
  </v-card>
</template>

<script>
import { axios, Strings } from '../../../utils'
import MonthPicker from '../../../components/MonthPicker'
export default {
  components: {
    MonthPicker
  },
  data() {
    return {
      loading: false,
      headers: [
        {
          text: 'Business Name',
          align: 'start',
          sortable: true,
          value: '0'
        },
        {
          text: 'Email',
          align: 'start',
          sortable: true,
          value: '1'
        },

        {
          text: 'Telephone',
          align: 'start',
          sortable: true,
          value: '3'
        },

        {
          text: 'Mobile',
          align: 'start',
          sortable: true,
          value: '4'
        },
        {
          text: 'Category',
          align: 'start',
          sortable: true,
          value: '5'
        },
        {
          text: 'Suburb',
          align: 'start',
          sortable: true,
          value: '6'
        },
        {
          text: 'Messages Sent',
          align: 'start',
          sortable: true,
          value: '7'
        }
      ],
      freeListingViews: [],
      month: ''
    }
  },
  mounted() {
    this.getFreeListingViews()
  },
  methods: {
    getFreeListingViews() {
      this.loading = true
      axios
        .get(
          `/api/new-free-listing-views?month=${
            this.month ? this.month : new Date().toISOString().substr(0, 7)
          }`
        )
        .then(res => {
          this.freeListingViews = res.data
          this.loading = false
        })
        .catch(err => console.log(err))
    },
    printReport() {
      window.open(
        `${Strings.baseUrl}/print-report?month=${
          this.month ? this.month : new Date().toISOString().substr(0, 7)
        }&type=free&name=NEW FREE LISTINGS REPORT`,
        '_blank'
      )
    }
  },
  watch: {
    month: function() {
      this.getFreeListingViews()
    }
  }
}
</script>

<style lang="scss" scoped></style>
